import React from 'react';
import Menu from './menu';
import Sidebar from './sidebar';
// import Footer from './footer';
import Footer from './footer';
import People from '../assets/peopletech-removebg-preview.png'; // Import the image file
import Microsoft from '../assets/microsoft.png'; // Import the image file
import Himansu from '../assets/himansu-removebg-preview.png'; // Import the image file
import Ecozera from '../assets/ecozera.png'; // Import the image file
const Profile = () => {
return (
<div>
   <div class="container mt-5">
      <div class="row">
         <div class="col-sm-12 col-lg-3 col-xl-3 col-md-3">
            <Sidebar/>
         </div>
         <div class="col-sm-12 col-lg-9 col-xl-9 col-md-9">
            <Menu/>
            <div class="bostami-page-content-wrap">
               <div class="section-wrapper pl-60 pr-60 pt-60">
                  <div class="bostami-page-title-wrap mb-15">
                     <div class="three">
                        <h1 class="">Profile</h1>
                     </div>
                     <div class="row mt-3">
                        <div class="bostami-section-title-wrap mb-20">
                           <h4 class="section-title mt-5"><i class="fa fa-briefcase"></i>Professional Experience</h4>
                        </div>
                           <div class="bostami-card-item bg-catkrill  mb-20 mt-3"  >
                              <img src={Microsoft} style={{height:'50px'}}/>
                              <span class="card-subtitle mt-3">Mar 2017 - Present</span>
                              <h6 class="card-title mt-3">Technical Lead</h6>
                              <p>As a Technical Lead at Microsoft, I am responsible for the design, development, and management of financial tools utilized by the Microsoft Finance team. My role involves overseeing the entire development lifecycle, ensuring the delivery of robust and efficient solutions that meet the highest standards of quality and performance.</p>
                           </div>
                           <div class="bostami-card-item bg-prink mb-20 mt-3" >
                              <img src={People} style={{height:'100px'}}/>
                              <span class="card-subtitle mt-3">Jul 2013 - Mar 2017</span>
                              <h6 class="card-title ">Technical Manager</h6>
                              <p class="card-text">As a Technical Manager at People Tech Group Inc, I led a team in designing, developing, and deploying high-performance applications. My responsibilities included overseeing the development lifecycle, coordinating teams, and implementing best practices. I also mentored junior developers and ensured client satisfaction with delivered solutions. Continuously monitoring and optimizing performance, I ensured our software met industry standards.</p>
                           </div>
                       
                           <div class="bostami-card-item bg-catkrill mb-20 mt-3" >
                              <img src={Himansu} style={{height:'100px'}}/>
                              <span class="card-subtitle mt-3">Feb 2010 - Jun 2013</span>
                              <h6 class="card-title">Senior Software Engineer</h6>
                              <p class="card-text">As a Senior Software Engineer at Himansu IT, I was responsible for developing and maintaining several critical projects. My work focused on enhancing functionality and performance, ensuring that each solution met the highest standards of quality and efficiency. </p>
                           </div>
                           <div class="bostami-card-item bg-prink mb-20 mt-3" >
                              <img src={Ecozera} style={{height:'50px'}}/>
                              <span class="card-subtitle mt-3">Apr 2009 - Feb 2010</span>
                              <h6 class="card-title ">Web Developer</h6>
                              <p class="card-text">As a Web Developer at ecomZera, I developed and maintained web applications, focusing on enhancing user experience and functionality. My role involved ensuring optimal performance and implementing best practices to deliver high-quality, user-centric solutions.
                              </p>
                           </div>
                       
                     </div>



                     <div class="row mt-5">
                        <div class="bostami-section-title-wrap  mb-20">
                        <h4 class="section-title mt-5"><i class="fa fa-graduation-cap"></i>Education</h4>

                        </div>
                        <div class="cols-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
                        <div class="bostami-card-wrap">
                                        <div class="bostami-card-item bg-prink mb-20">
                                            <span class="card-subtitle">2006-2009</span>
                                            <h6 class="card-title">Master of Computer Applications - MCA,  <span>- Computer Science,</span></h6>
                                            <p class="card-text">Sri Venkateswara University</p>
                                        </div>

                                        <div class="bostami-card-item bg-catkrill mb-20">
                                            <span class="card-subtitle">2003-2006</span>
                                            <h6 class="card-title">Computer Science <span>- B.SC MECS, Com</span></h6>
                                            <p class="card-text">MSR Degree College, Kavali</p>
                                        </div>

                                       
                                    </div>
                        </div>
                        <div class="cols-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
                        <div class="bostami-card-item bg-catkrill">
                                            <span class="card-subtitle">2001-2003</span>
                                            <h6 class="card-title">MPC,<span>- Mathematics, Physics and Chemistry</span></h6>
                                            <p class="card-text">R.K Jr College Allure</p>
                                        </div>
                        </div>
                     </div>



























                  </div>
               </div>
               <div className="section-wrapper bg-light-white-2 pt-70 pb-60 pl-60 pr-60 mt-4">
                  <div className="row">
                     <div className="col-xl-6 col-lg-7">
                        <div className="bostami-section-title-wrap mb-20">
                           <h4 className="section-title">Skills and Proficiency</h4>
                        </div>
                        <div className="skill-bar-wrap">
                           <div className="skill-bar-item mb-30">
                              <div className="title-wrap">
                                 <h5 className="title">Technical Lead</h5>
                                 <span className="count">85%</span>
                              </div>
                              <div className="progress-bar-wrap">
                                 <div className="progress-line progress-bg-1" style={{ width: '85%' }}>
                              </div>
                           </div>
                        </div>
                        <div className="skill-bar-item mb-30">
                           <div className="title-wrap">
                              <h5 className="title">Full-Stack Developer</h5>
                              <span className="count">90%</span>
                           </div>
                           <div className="progress-bar-wrap">
                              <div className="progress-line progress-bg-2" style={{ width: '90%' }}>
                           </div>
                        </div>
                     </div>
                     <div className="skill-bar-item mb-30">
                        <div className="title-wrap">
                           <h5 className="title">Azure Application Developer</h5>
                           <span className="count">80%</span>
                        </div>
                        <div className="progress-bar-wrap">
                           <div className="progress-line progress-bg-3" style={{ width: '80%' }}>
                        </div>
                     </div>
                  </div>
                  <div className="skill-bar-item mb-30">
                     <div className="title-wrap">
                        <h5 className="title">Azure Data Engineer</h5>
                        <span className="count">80%</span>
                     </div>
                     <div className="progress-bar-wrap">
                        <div className="progress-line progress-bg-4" style={{ width: '82%' }}>
                     </div>
                  </div>
               </div>
               <div className="skill-bar-item mb-30">
                     <div className="title-wrap">
                        <h5 className="title">Database Developer</h5>
                        <span className="count">80%</span>
                     </div>
                     <div className="progress-bar-wrap">
                        <div className="progress-line progress-bg-5" style={{ width: '80%' }}>
                     </div>
                  </div>
               </div>
               <div className="skill-bar-item mb-30">
                     <div className="title-wrap">
                        <h5 className="title">SharePoint Developer</h5>
                        <span className="count">70%</span>
                     </div>
                     <div className="progress-bar-wrap">
                        <div className="progress-line progress-bg-6" style={{ width: '70%' }}>
                     </div>
                  </div>
               </div>
               <div className="skill-bar-item mb-30">
                     <div className="title-wrap">
                        <h5 className="title">Power BI Specialist</h5>
                        <span className="count">70%</span>
                     </div>
                     <div className="progress-bar-wrap">
                        <div className="progress-line progress-bg-7" style={{ width: '70%' }}>
                     </div>
                  </div>
               </div>
               <div className="skill-bar-item mb-30">
                     <div className="title-wrap">
                        <h5 className="title">DevOps Engineer</h5>
                        <span className="count">70%</span>
                     </div>
                     <div className="progress-bar-wrap">
                        <div className="progress-line progress-bg-8" style={{ width: '70%' }}>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="col-xl-6 col-lg-5">
            <div className="bostami-section-title-wrap mb-20">
               <h4 className="section-title">Knowledge Areas</h4>
            </div>
            <div className="knowledeges-item-wrap">
               <span className="gk-item">.NET Full-Stack Development</span>
               <span className="gk-item">MERN Stack Development</span>
               <span className="gk-item">Microsoft Business Intelligence (MSBI)</span>
               <span className="gk-item">Azure Application Development</span>
               <span className="gk-item">Azure Data Engineering</span>
               <span className="gk-item">SharePoint Development</span><br/>
               <span className="gk-item">Power BI</span><br/>
               <span className="gk-item">MongoDB</span><br/>
               <span className="gk-item">Azure DevOps</span>
            </div>
         </div>
      </div>
   </div>
   <Footer/>
</div>
</div>
</div>
</div>
</div>
);
}
export default Profile;